export enum EditorModes {
  Normal = 'Normal',
  ViewOnly = 'ViewOnly',
}

class EditorMode {
  mode: EditorModes = EditorModes.Normal;
}

export default EditorMode;
